module.exports = __webpack_public_path__ + "static/img/HY-S5.4f8142a2.png";